import qs from 'query-string';

import { ProfileTypes } from '../../../types';

function getViewAllUrl(
  profileGuid: string,
  { seekProfilesOnly }: { seekProfilesOnly: boolean },
): string {
  return `profiles/${profileGuid}/similar-candidates?${qs.stringify({
    isSeedProfileLocationOnly: true,
    profileTypes: seekProfilesOnly
      ? [ProfileTypes.Seek]
      : [ProfileTypes.Combined],
  })}`;
}

export default getViewAllUrl;
